<template>
  <div>
    <v-container style="max-width: unset" class="d-flex-column pa-5 pt-0">
      <v-card class="mx-auto box-shadow" max-width="100%">
        <div style="width: 100%">
          <v-card-title class="card-title">
            <v-icon class="pr-2" @click="voltar" color="#BC0000"
              >mdi-arrow-left</v-icon
            >
            <v-icon
              class="d-flex-row justify-center pl-2 pt-3"
              large
              color="normalred"
            >
              mdi-clipboard-outline
            </v-icon>
            <span style="color: #bc0000"> Meus serviços </span>
          </v-card-title>

          <v-card-text class="card-text pl-7">
            Atualize seus serviços oferecidos.
          </v-card-text>
        </div>
      </v-card>

      <!--Especialidades -->
      <v-card v-if="true" class="box-shadow" max-width="100%">
        <v-icon class="pl-7 pt-3" large color="normalred"> mdi-brain </v-icon>

        <span class="text-span">Especialidades</span>

        <span class="pl-7 pb-2" style="display: block">
          Selecione a(s) especialidade(s) de aplicação dos adesivos, elas serão
          importantes para indicarmos aos clientes.
        </span>

        <v-row
          v-if="checked"
          class="px-7"
          align="center"
          cols="12"
          sm="6"
          md="3"
          lg="3"
        >
          <v-list-item
            v-for="(item, idx) in specialties"
            :key="idx"
            class="d-block"
          >
            <template v-slot:default="{ active }">
              <v-list-item-action>
                <v-checkbox
                  type="checkbox"
                  color="deep-purple"
                  class="ma-0 pb-0 pt-0 black--text"
                  v-model="item.checked"
                  :input-value="active"
                  :key="idx"
                  :label="item.name"
                  :value="item.checked"
                  :checked="item.checked"
                >
                </v-checkbox>
              </v-list-item-action>
            </template>
          </v-list-item>
        </v-row>
      </v-card>

      <v-card class="box-shadow">
        <v-row class="justify-center pl-2 px-2">
          <v-col cols="12" sm="6" md="6" lg="6">
            <v-btn
              large
              height="45"
              width="100%"
              style="border-radius: 8px !important"
              class=""
              @click="voltar()"
            >
              Voltar
            </v-btn>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="6">
            <v-btn
              large
              width="100%"
              height="45"
              class="d-flex justify-content-center"
              style="
                border-radius: 8px !important;
                font-weight: bold;
                font-size: 18px;
              "
              color="normalred"
              @click="sucessDialog = true"
            >
              Atualizar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-dialog v-model="sucessDialog" max-width="600px">
        <ConfirmModalAdd
          :title="'Atualizar lista de serviço'"
          :textMessage="'Atualizar lista de serviço'"
          :okbtn="'Atualizar'"
          :cancelBtn="'Cancelar'"
          :textObservation1="''"
          :textObservation2="''"
          :icone="'mdi-restore-alert'"
          @close="sucessDialog = false"
          @actionOK="submit()"
          @actionCancel="sucessDialog = false"
        />
      </v-dialog>
    </v-container>
  </div>
</template>

<style scoped>
.box-shadow {
  box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1) !important;
}
input[type="checkbox"] + label {
  color: #000;
}

input[type="checkbox"]:checked + label {
  font-weight: bold;
}

input[type="checkbox"]:disabled + label {
  color: #999;
}

.text-span {
  color: #000000;
  font-weight: bold;
  font-size: large;
  text-align: left;
}
.black--text /deep/ label {
  color: black;
  font-size: 15px;
}
.item span {
  font-size: 1.05rem;
  color: #fff;
}

.mytable .v-table tbody tr {
  border-left: 5px solid red !important;
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}

@media screen and (max-width: 700px) {
  .theme--light.v-data-table thead tr:last-child th,
  .theme--light.v-data-table tbody tr:not(:last-child) td:last-child,
  .theme--light.v-data-table tbody tr td,
  .theme--light.v-data-table
    tbody
    tr:not(:last-child)
    td:not(.v-data-table__mobile-row) {
    border-bottom: medium solid black !important;
  }
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import ConfirmModalAdd from "../components/ConfirmModalAdd.vue";

export default {
  name: "Register",

  props: {},

  components: {
    ConfirmModalAdd,
  },

  async created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    await this.listSpecialties();
  },

  data: () => ({
    user: {},
    clear: false,
    checked: false,
    dialog: false,
    sucessDialog: false,
    apiService: new ApiService(),
    specialties: [],
  }),

  watch: {},

  methods: {
    close() {
      this.$emit("close");
    },

    voltar() {
      this.$router.push("/dashboard");
    },

    async listSpecialties() {
      await this.apiService
        .get(`specialties/list`)
        .then((response) => {
          this.getInstaller();
          this.specialties = response;
        })
        .catch((err) => {});
    },

    async getInstaller() {
      await this.apiService
        .get(`installer/get-one?id=${this.user.id}`)
        .then((installer) => {
          const specialties = installer.specialties;
          this.specialties.forEach((x) => {
            x.checked =
              specialties.find((i) => i.specialties.id === x.id) != null;
          });
          this.checked = true;
        })
        .catch((err) => {});
    },

    async submit() {
      this.sucessDialog = false;
      const model = {
        Id: this.user.id,
        Specialties: [],
      };
      this.specialties
        .filter((x) => x.checked)
        .forEach((item) => {
          model.Specialties.push({
            SpecialtiesId: item.id,
          });
        });
      let url = "installer/update-installer-services";
      await this.apiService
        .put(url, model)
        .then((resp) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Serviços atualizados",
            trace: null,
          });
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível atualizar os serviços do aplicador!",
            trace: null,
          });
        });
    },
  },
};
</script>
